import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { AdminBar } from "./cms/AdminBar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-cream">
      <AdminBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
